/* Reviews Section (Aqua) - Slider Functionality */

(function() {
  'use strict';

  function initReviewsSlider() {
    const sliders = document.querySelectorAll('[data-reviews-slider]');

    sliders.forEach(function(slider) {
      const track = slider.querySelector('[data-reviews-track]');
      const container = slider.closest('.reviews-section__slider-container');
      const prevBtn = container.querySelector('[data-reviews-prev]');
      const nextBtn = container.querySelector('[data-reviews-next]');
      const cards = track.querySelectorAll('.reviews-section__card');

      if (!track || cards.length === 0) return;

      let currentIndex = 0;
      let cardsPerView = getCardsPerView();

      function getCardsPerView() {
        if (window.innerWidth <= 749) {
          return 1;
        } else if (window.innerWidth <= 1200) {
          return 2;
        }
        return 3;
      }

      function updateSlider() {
        const cardWidth = cards[0].offsetWidth;
        const gap = 30;
        const offset = currentIndex * (cardWidth + gap);
        track.style.transform = 'translateX(-' + offset + 'px)';
      }

      function goToNext() {
        const maxIndex = Math.max(0, cards.length - cardsPerView);
        if (currentIndex < maxIndex) {
          currentIndex++;
          updateSlider();
        } else {
          // Loop back to start
          currentIndex = 0;
          updateSlider();
        }
      }

      function goToPrev() {
        if (currentIndex > 0) {
          currentIndex--;
          updateSlider();
        } else {
          // Loop to end
          currentIndex = Math.max(0, cards.length - cardsPerView);
          updateSlider();
        }
      }

      // Event listeners
      if (nextBtn) {
        nextBtn.addEventListener('click', goToNext);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', goToPrev);
      }

      // Handle resize
      let resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          cardsPerView = getCardsPerView();
          currentIndex = Math.min(currentIndex, Math.max(0, cards.length - cardsPerView));
          updateSlider();
        }, 250);
      });

      // Touch/swipe support for mobile
      let touchStartX = 0;
      let touchEndX = 0;

      slider.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      slider.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }, { passive: true });

      function handleSwipe() {
        const swipeThreshold = 50;
        const diff = touchStartX - touchEndX;

        if (diff > swipeThreshold) {
          // Swipe left - go next
          goToNext();
        } else if (diff < -swipeThreshold) {
          // Swipe right - go prev
          goToPrev();
        }
      }

      // Initialize
      updateSlider();
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewsSlider);
  } else {
    initReviewsSlider();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('[data-reviews-slider]')) {
      initReviewsSlider();
    }
  });
})();
